/* ash-video-sound — ONLY the click handler. Positioning is pure CSS. */
(function () {
  if (window.__ashVideoSoundInit) return;
  window.__ashVideoSoundInit = true;

  function isVisibleEl(el) {
    if (!el || el.offsetParent === null) return false;
    var s = window.getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden';
  }
  function findVideoFor(btn) {
    var host = btn.closest('[data-ash-video-host]');
    if (host) {
      var all = host.querySelectorAll('video');
      for (var i = 0; i < all.length; i++) {
        if (isVisibleEl(all[i])) return all[i];
      }
      if (all[0]) return all[0];
    }
    var parent = btn.parentElement;
    if (parent) {
      var v2 = parent.querySelector('video');
      if (v2) return v2;
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ash-video-sound]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var video = findVideoFor(btn);
    if (!video) return;
    var nowMuted = !video.muted;
    video.muted = nowMuted;
    if (!nowMuted) {
      if (typeof window.__ashVideoLazyArm === 'function') window.__ashVideoLazyArm(video);
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
    btn.setAttribute('aria-pressed', nowMuted ? 'false' : 'true');
    var muted = btn.querySelector('.ash-video-sound__icon--muted');
    var on    = btn.querySelector('.ash-video-sound__icon--on');
    if (muted) muted.style.display = nowMuted ? 'inline-flex' : 'none';
    if (on)    on.style.display    = nowMuted ? 'none' : 'inline-flex';
  });
})();
